const prefixStyles = [
  "color: lightCoral",
  "font-size: 12px",
  "font-weight: bolder",
  "padding-left: 10px",
  "padding-right: 5px"
].join(";");
const contextStyles = ["color: goldenRod", "font-size: 12px", "font-weight: bolder", "padding-right: 10px"].join(";");
function createLogger(id, debugMode) {
  return (context, ...args) => {
    if (debugMode === "verbose") {
      console.log(`%c[${id}] %c${context}`, prefixStyles, contextStyles, ...args);
    }
  };
}
export {
  createLogger
};
//# sourceMappingURL=createLogger.js.map
